/**
 * Copyright (c) 2019-Present Syncari - All rights reserved.
 *
 * Design tokens — Primitive color palette
 * Source of truth: Figma Design System > Color Primitives (node 4775:32)
 *
 * These are raw color values. Components should NOT import from this file
 * directly — use semantics.ts instead. Primitives are only consumed by:
 *   1. semantics.ts (to define purpose-based aliases)
 *   2. tokens.less   (to define CSS custom properties)
 */

export const brand = {
  100: '#D6E2FF',
  200: '#AEC5FF',
  300: '#87A8FF',
  400: '#6288FB',
  500: '#4066F6',
  600: '#304EC1',
  700: '#21388F',
  800: '#13235F',
  900: '#060F34',
  1000: '#01020E',
} as const;

export const accent = {
  100: '#FEEEDD',
  200: '#FDDDBA',
  300: '#FCCC96',
  400: '#F9BA70',
  500: '#F6A841',
  600: '#C18331',
  700: '#8F6022',
  800: '#5F3F13',
  900: '#342006',
  1000: '#0E0601',
} as const;

export const neutrals = {
  white: '#FFFFFF',
  100: '#F5F5F5',
  200: '#E6E6E6',
  300: '#D9D9D9',
  400: '#B3B3B3',
  500: '#757575',
  600: '#444444',
  700: '#383838',
  800: '#2C2C2C',
  900: '#1E1E1E',
  1000: '#111111',
  black: '#000000',
} as const;

export const green = {
  100: '#EBFFEE',
  200: '#CFF7D3',
  300: '#AFF4C6',
  400: '#85E0A3',
  500: '#14AE5C',
  600: '#009951',
  700: '#008043',
  800: '#02542D',
  900: '#024023',
  1000: '#062D1B',
} as const;

export const yellow = {
  100: '#FFFBEB',
  200: '#FFF1C2',
  300: '#FFE8A3',
  400: '#E8B931',
  500: '#E5A000',
  600: '#BF6A02',
  700: '#975102',
  800: '#682D03',
  900: '#522504',
  1000: '#401B01',
} as const;

export const red = {
  100: '#FEE9E7',
  200: '#FDD3D0',
  300: '#FCB3AD',
  400: '#F4776A',
  500: '#EC221F',
  600: '#C00F0C',
  700: '#900B09',
  800: '#690807',
  900: '#4D0B0A',
  1000: '#300603',
} as const;
